export function addGlobalEventListener(
    type,
    selector,
    callback,
    options,
    parent = document
) {
    parent.addEventListener(
        type,
        e => {
            if (e.target.matches(selector)) {
                callback(e)
                return;
            }
            if (e.target.closest(selector)){
                callback(e)
                return;
            }
        },
        options
    )
}

export function qs(selector, parent = document) {
    return parent.querySelector(selector)
}

export function qsa(selector, parent = document) {
    return [...parent.querySelectorAll(selector)]
}

export function createElement(type, options = {}) {
    const element = document.createElement(type)
    Object.entries(options).forEach(([key, value]) => {
        if (key === "class") {
            element.classList.add(...value)
            return
        }

        if (key === "dataset") {
            Object.entries(value).forEach(([dataKey, dataValue]) => {
                element.dataset[dataKey] = dataValue
            })
            return
        }

        if (key === "text") {
            element.textContent = value
            return
        }

        element.setAttribute(key, value)
    })
    return element
}

export async function appendScript(src) {
    await $.getScript(src, () => {
    })
}

export function appendStyle(src, prepend = true) {
    let element = createElement('link', {
        rel: 'stylesheet',
        type: 'text/css',
        href: src
    })

    if (prepend){
        document.head.prepend(element)
    } else {
        document.head.appendChild(element)
    }
}
